import { render } from "./Authorization.vue?vue&type=template&id=8e2306bc&scoped=true"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e2306bc"]])

export default __exports__